import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import {getCookie} from './utils'

Vue.config.productionTip = false


import './styles/domain.scss';


import Toastr from 'vue-toastr';
// import 'vue-toastr/dist/vue-toastr.css';
import Print from 'vue-print-nb';
import API from '@/api.js'
let Base64 = require('js-base64').Base64;
Vue.prototype.$api = API;
import VueI18n from 'vue-i18n'

Vue.use(Print);
Vue.use(Toastr);
Vue.use(ElementUI);
Vue.use(Base64);
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: getCookie('domainLanguage') || 'zh',  // 语言标识
  messages: {
    'zh': require('./i18n/zh'),
    'en': require('./i18n/en'),
    'cn': require('./i18n/cn')
  }
})
//Vue.use(QRCode);

import { JSEncrypt } from 'jsencrypt' //RSA密码加密bcx
//JSEncrypt加密方法
let PUBLIC_KEY="MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA+TWzUflAOqz7cFOCe06IECO3Jq6kV5rPrVhhUbKHc5xqUr2ruW69UXCz3EOjFXhWf/Ubr2ysDexxV8lLP5kP9buk3Bvz+caepRR5K5DlBh8oF11AwlcGTSVetMrzm4nyDHVCq2pF7NeF/J/sFZr+tlU/xnI6blq+ZTlIIVubRkmsUttFQamX3L9ACUukaanHv9AFrTwPtzCb1wSULJCEgo32UKK2pBh5I0XxL8JoBP/PuBDSsVp/sysh9bPdptPGRE5DgqTQAk+rz25+1xTtlWyIIhpMCHpJXlIdDqVq8x9d3NsLGpVH7FYXiLiPil07h/KkPAM3pnUQUTQ7SI6YmQIDAQAB"
Vue.prototype.$getCodeRSA = function(password) {
  //new一个对象
  let encrypt = new JSEncrypt()
  //设置公钥
  encrypt.setPublicKey(PUBLIC_KEY)
  //password是要加密的数据,此处不用注意+号,因为rsa自己本身已经base64转码了,不存在+,全部是二进制数据
  let result = encrypt.encrypt(password)
  return result
}

//高德地图
import VueAMap from 'vue-amap'
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'c4de786c74a450ac841ea096528c6ff1',//注册高德地图应用key
  plugin: ['AMap.Autocomplete','AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.AMapManager','AMap.Geolocation'],
  v: '1.4.4',
  uiVersion: '1.0.11'
});


new Vue({
  router,
  store,
  i18n,
  data: function () {
    return {
      adminToken: ''
    }
  },
  render: h => h(App)
}).$mount('#app')
